import api from "@/api/api-v2-config";

export async function getTaxListAxios() {    
    return await api.get("taxs/tax");
}

export async function deleteTaxAxios(id) {    
    return await api.delete("taxs/" + id);
}

export async function postTaxAxios(tax) {    
    return await api.post("taxs/tax", tax);
}

export async function putTaxAxios(tax) {    
    return await api.put("taxs", tax);
}

export async function getTaxByIDAxios(id) {    
    return await api.get("taxs/" + id);
}